module.exports = __webpack_public_path__ + "img/development-during-recession-top-og-img.d386c32c.jpg";